<template>
    <div class="dashboard tk-engagements-page">
        <PageBanner title="Engagements" subtext="Individual and group service delivery." />

        <section class="tk-engagements-tabs-row">
            <q-tabs class="tabs-container tk-engagements-tabs" active-color="primary" :model-value="activeTab">
                <q-route-tab no-caps class="client-graph-tab" name="my" label="Clients" :to="{ name: 'tkClients' }" />
                <q-route-tab no-caps class="client-graph-tab" name="service" label="Service Client List" :to="{ name: 'tkServiceDashboard' }" />
                <q-route-tab no-caps class="client-graph-tab" name="enquiries" label="Enquiries" :to="{ name: 'tkEnquiries' }" />
                <q-route-tab no-caps class="client-graph-tab" name="groups" label="Groups" :to="{ name: 'tkGroups' }" />
            </q-tabs>
        </section>

        <main class="tk-engagements-content">
            <router-view />
        </main>
    </div>
</template>

<script>
import PageBanner from "@/components/ClientComponents/DashboardComponents/PageBanner.vue";

const tabsByRouteName = Object.freeze({
    tkClients: "my",
    tkServiceDashboard: "service",
    tkEnquiries: "enquiries",
    tkGroups: "groups",
});

export default {
    name: "TkEngagements",
    components: { PageBanner },
    computed: {
        activeTab() {
            return tabsByRouteName[this.$route.name];
        },
    },
};
</script>

<style src="../assets/styles/tkEngagements.css"></style>
